import { getCookie, setCookie } from "@/utils/cookies";
import ms from "ms";

const cookieName = "liked-posts";
const sep = ",";
const ttl = ms("1y");

const deserializeLikedPosts = (likedPostsStr?: string): number[] => {
  if (likedPostsStr) {
    return likedPostsStr.split(sep).map(Number);
  } else {
    return [];
  }
};
export const getLikedPosts = async () => {
  const likedPostsStr = await getCookie(cookieName);
  return deserializeLikedPosts(likedPostsStr);
};

const serializeLikedPosts = (posts: number[]): string => {
  return posts.join(sep);
};
export const setLikedPosts = (posts: number[]) => {
  setCookie(cookieName, serializeLikedPosts(posts), {
    expires: ttl,
  });
};
